module.exports = __webpack_public_path__ + "static/el-financiero-178cea7bfa17f4d54dee6e601b188c8d.png";